import React, { PureComponent } from 'react';
import {
  Card, CardBody, Col, Button, ButtonToolbar,
} from 'reactstrap';  
import { reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { hasAccess } from "../../Services/SecurityService";
import { updateEstado } from "../../Services/EstadoService";
import { FullWideNotification } from '../../../shared/components/Notification';
import NotificationSystem from 'rc-notification';

let notificationTC = null;

class CrudEdit extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      climas: [],
      checkboxClimas: [],
      checkboxClimasSelected: [],
      geologias: [],
      checkboxGeologias: [],
      checkboxGeologiasSelected: [],
      data: {
        id: '',
        name: '',
        uf: '',
        descriptionClima: '',
        createdAt: '',
        updatedAt: ''
      }
    };
  }

  handleSubmit(e){
    const data = { ...this.state.data }

    if(this.validateEntries()){
      let request = {
        estado: this.state.data,
        geologiaEstadoList: this.getGeologiaEstado(),
        climaEstadoList: this.getClimaEstado()
      };
  
      if(data.id === undefined || data.id === null || data.id === ''){
        this.show('danger', this.props.t('forms.requiredFieldStateIdNull'));
      }else{
        updateEstado(request)
        .then(obj => {
          if(obj !== null && obj !== undefined && obj.error === undefined){
            if(obj.erros.length === 0){
              this.props.updateTable(obj, this.props.t('forms.dataUpdateSuccess'));
              this.props.updateTable(obj);
            }else{
              if(obj.erros !== undefined && obj.erros !== undefined && obj.erros.length > 0){
                for(let i = 0; i < obj.erros.length; i++){
                  this.show('danger', this.props.t('erros.'+obj.erros[i]));
                }
              }  
            }
          } else {
            this.show('danger', this.props.t('forms.dataUpdateError'));
          }
        });
      }
    }
  }

  validateEntries(){
    const data = { ...this.state.data }
    let validated = true;

    if(data.name === undefined || data.name === null || data.name === ''){
      this.show('danger', this.props.t('forms.requiredFieldName'));
      validated = false;
    }

    if(data.uf === undefined || data.uf === null || data.uf === ''){
      this.show('danger', this.props.t('forms.requiredFieldUF'));
      validated = false;
    }

    return validated;  
  }

  getGeologiaEstado() {
    let geologiaEstado = [];
    if(this.state.checkboxGeologiasSelected.length > 0){
      for(let j = 0; j < this.state.checkboxGeologiasSelected.length; j++){
        for(let i = 0; i < this.state.geologias.length; i++){
          if(this.state.checkboxGeologiasSelected[j].value === this.state.geologias[i].id){
            geologiaEstado.push( {geologia: this.state.geologias[i]} );
            break;
          }
        }
      }
    }
    return geologiaEstado;
  }

  getClimaEstado() {
    let climaEstado = [];
    if(this.state.checkboxClimasSelected.length > 0){
      for(let j = 0; j < this.state.checkboxClimasSelected.length; j++){
        for(let i = 0; i < this.state.climas.length; i++){
          if(this.state.checkboxClimasSelected[j].value === this.state.climas[i].id){
            climaEstado.push( {clima: this.state.climas[i]} );
            break;
          }
        }
      }
    }
    return climaEstado;
  }

  loadData(selected, estados, climas, climaEstado, geologias, geologiaEstado) {
    let options = [];
    let optionsSelected = [];
    let obj = {};
    if(estados !== undefined && estados !== null && estados.length > 0 && this.state.estados.length === 0){
      for(let i = 0; i < estados.length; i++){
        options.push({value:estados[i].id, label: estados[i].name});
      }
      this.setState({ 
        selectOptions: options, 
        estados: estados 
      });
    }
    if(climas !== undefined && climas !== null && climas.length > 0 && this.state.climas.length === 0){
      options = [];
      optionsSelected = [];
      if(climaEstado !== undefined && climaEstado !== null && climaEstado.length > 0){
        for(let i = 0; i < climas.length; i++){
          obj = {value:climas[i].id, label: climas[i].description + " ("+climas[i].name+")", checked: false};
          for(let j = 0; j < climaEstado.length; j++){
            if(climas[i].id === climaEstado[j].clima.id){
              obj.checked = true;
              optionsSelected.push(obj);
              break;
            }
          }
          options.push(obj);
        }
      }else{
        for(let i = 0; i < climas.length; i++){
          options.push({value:climas[i].id, label: climas[i].description + " ("+climas[i].name+")", checked: false});
        }
      }
      
      this.setState({ 
        checkboxClimas: options,
        checkboxClimasSelected: optionsSelected,
        climas: climas 
      });
    }
    if(geologias !== undefined && geologias !== null && geologias.length > 0 && this.state.geologias.length === 0){
      options = [];
      optionsSelected = [];
      if(geologiaEstado !== undefined && geologiaEstado !== null && geologiaEstado.length > 0){
        for(let i = 0; i < geologias.length; i++){
          obj = {value:geologias[i].id, label: geologias[i].simb1000, checked: true};
          for(let j = 0; j < geologiaEstado.length; j++){
            if(geologias[i].id === geologiaEstado[j].geologia.id){
              obj.checked = true;
              optionsSelected.push(obj);
              break;
            }
          }
          options.push(obj);
        }
      }else{
        for(let i = 0; i < geologias.length; i++){
          options.push({value:geologias[i].id, label: geologias[i].simb1000, checked: false});
        }
      }

      this.setState({ 
        checkboxGeologias: options, 
        checkboxGeologiasSelected: optionsSelected,
        geologias: geologias 
      });
    }
    if(selected !== undefined && selected !== null && selected.id > 0 && this.state.data.id === ''){
      this.setState({ 
        data: selected
      }, () => {});
      //window.scrollTo(0,72);
    }
  }

  componentDidMount() {
    const { selected, estados, climas, climaEstado, geologias, geologiaEstado  } = this.props;
    this.loadData(selected, estados, climas, climaEstado, geologias, geologiaEstado);
    NotificationSystem.newInstance({ style: { top: 65 } }, n => notificationTC = n);
  }

  componentDidUpdate(props, state) {
    if(props.selected !== this.props.selected || props.estados !== this.props.estados || 
        props.climas !== this.props.climas || props.climaEstado !== this.props.climaEstado || 
        props.geologias !== this.props.geologias || props.geologiaEstado !== this.props.geologiaEstado){
      this.loadData(this.props.selected, this.props.estados, this.props.climas, this.props.climaEstado, this.props.geologias, this.props.geologiaEstado);
    }
  }

  componentWillUnmount() {
    notificationTC.destroy();
  }



  updateField(event) {
    const data = { ...this.state.data }
    data[event.target.name] = event.target.value
    this.setState({ data });
  }

  updateCheckboxGeologia(event) {
    let selecteds = [];
    event.checked = !event.checked;
    if(this.state.checkboxGeologiasSelected.length > 0){
      for(let i = 0; i < this.state.checkboxGeologiasSelected.length; i++){
        if(this.state.checkboxGeologiasSelected[i].value !== event.value){
          selecteds.push(this.state.checkboxGeologiasSelected[i]);
        }
      }
    }
    if(event.checked){
      selecteds.push(event);
    }
    this.setState({ checkboxGeologiasSelected: selecteds });
  }

  updateCheckboxClima(event) {
    let selecteds = [];
    event.checked = !event.checked;
    if(this.state.checkboxClimasSelected.length > 0){
      for(let i = 0; i < this.state.checkboxClimasSelected.length; i++){
        if(this.state.checkboxClimasSelected[i].value !== event.value){
          selecteds.push(this.state.checkboxClimasSelected[i]);
        }
      }
    }
    if(event.checked){
      selecteds.push(event);
    }
    this.setState({ checkboxClimasSelected: selecteds });
  }

  clear(){
    const data = { ...this.state.data }
    data['id'] = '';
    data['name'] = '';
    data['uf'] = '';
    data['descriptionClima'] = false;
    data['createdAt'] = '';
    data['updatedAt'] = '';
    this.setState({ 
      data,
      checkboxClimas: [],
      checkboxClimasSelected: [],
      checkboxGeologias: [],
      checkboxGeologiasSelected: []
    }, () => {});
  }

  cancel(event) {
    this.clear();
    this.props.updateTable({});
  }

  show = (color, message) => {
    return notificationTC.notice({
      content: <FullWideNotification
        color={color}
        message={message}
        />,
      duration: 3,
      closable: true,
      style: { top: 0, left: 0 },
      className: `full ltr-support`,
    });
  };

  render() {
    const { t } = this.props;
    
    let notOK = !hasAccess("MENU_STATE_SAVE");

    let isEdit = false;
    if(this.state.data.id !== '' && this.state.data.id > 0){
      isEdit = true;
    }

    let checkboxesClimas = [];
    let checkboxesGeologias = [];

    let total = this.state.checkboxClimas.length;
    if(total > 0){
      for(let i = 0; i < total; i++){
          checkboxesClimas.push(
            <div key={"divclimas_"+this.state.checkboxClimas[i].value} className='form__form-inline' style={{width: '400px'}}>
              <input type="checkbox" 
                id={"checkboxclimas_"+this.state.checkboxClimas[i].value} 
                name={"checkboxclimas_"+this.state.checkboxClimas[i].value} 
                style={{float: 'left', width: '30px', height: '18px'}}
                onChange={e => this.updateCheckboxClima(this.state.checkboxClimas[i])}
                checked={this.state.checkboxClimasSelected.includes(this.state.checkboxClimas[i])} 
              />
                <label 
                  key={"labelclimas_"+this.state.checkboxClimas[i].value}
                  htmlFor={"checkboxclimas_"+this.state.checkboxClimas[i].value} 
                  style={{margin: 0, height: '25px'}}>
                  {this.state.checkboxClimas[i].label}
                </label>
            </div>
          );
      }
    }

    total = this.state.checkboxGeologias.length;
    if(total > 0){
      for(let i = 0; i < total; i++){
        checkboxesGeologias.push(
          <div key={"divgeologias_"+this.state.checkboxGeologias[i].value} className='form__form-inline' style={{width: '205px'}}>
            <input type="checkbox" 
              id={"checkboxgeologias_"+this.state.checkboxGeologias[i].value} 
              name={"checkboxgeologias_"+this.state.checkboxGeologias[i].value} 
              style={{float: 'left', width: '30px', height: '18px'}}
              onChange={e => this.updateCheckboxGeologia(this.state.checkboxGeologias[i])}
              checked={this.state.checkboxGeologiasSelected.includes(this.state.checkboxGeologias[i])} 
            />
              <label 
                key={"labelgeologias_"+this.state.checkboxGeologias[i].value}
                htmlFor={"checkboxgeologias_"+this.state.checkboxGeologias[i].value} 
                style={{margin: 0, height: '25px'}}>
                {this.state.checkboxGeologias[i].label}
              </label>
          </div>
        );
      }
    }

    return (
      <Col md={12} lg={12}>
        <Card>
          <CardBody>
            <div className="form__form-group">
              <h3 className="page-subhead subhead">{t('forms.createUpdate')}</h3>
            </div>
            <div className="form">
              <div className="form__half">
                <div className="form__form-group">
                  <span title={t('forms.requiredField')} className="form__form-group-label">
                    {t('forms.name')} <span style={{color: "#ff0000"}}>*</span>
                  </span>
                  <div className="form__form-group-field">
                    <input type="hidden" 
                      name="id"
                      value={this.state.data.id} />
                    <input type="text" 
                      name="name"
                      value={this.state.data.name}
                      onChange={e => this.updateField(e)}
                      required
                    />
                  </div>
                </div>
              </div>
              <div className="form__half">
                <div className="form__form-group">
                  <span title={t('forms.requiredField')} className="form__form-group-label">
                    {t('forms.uf')} <span style={{color: "#ff0000"}}>*</span>
                  </span>
                  <div className="form__form-group-field">
                    <input type="text" 
                      name="uf"
                      value={this.state.data.uf}
                      onChange={e => this.updateField(e)}
                      required
                    />
                  </div>
                </div>
              </div>
              <div className="form__form-group">
                <span title={t('forms.requiredField')} className="form__form-group-label">
                  {t('forms.clima_form.title')} 
                </span>
                <div className="form__form-group-field" 
                  style={{border: '1px solid #CCCCCC', height: '160px', overflowY: 'auto', 
                          display: 'flow-root', flexWrap: 'wrap', paddingTop: '5px'}}>
                  
                  {checkboxesClimas}

                </div>
              </div>
              <div className="form__form-group">
                <span title={t('forms.requiredField')} className="form__form-group-label">
                  {t('forms.geologia_form.title')} 
                </span>
                <div className="form__form-group-field" 
                  style={{border: '1px solid #CCCCCC', height: '400px', overflowY: 'auto', 
                          display: 'flow-root', flexWrap: 'wrap', paddingTop: '5px'}}>
                  
                  {checkboxesGeologias}

                </div>
              </div>
              <div className="form__form-group">
                <span title={t('forms.requiredField')} className="form__form-group-label">
                  {t('forms.descriptionClima')} 
                </span>
                <div className="form__form-group-field">
                  <textarea 
                    name="descriptionClima"
                    value={this.state.data.descriptionClima || ""}
                    style={{width: "100%", height: "60px"}}
                    onChange={e => this.updateField(e)}
                  />
                </div>
              </div>
              <ButtonToolbar className="form__button-toolbar">
                <Button color="primary" type="submit" disabled={notOK}
                  onClick={e => this.handleSubmit(e)}>
                  {t('forms.save')}
                </Button>
                <Button type="button" onClick={e => this.cancel(e)}>
                  {isEdit ? t('forms.voltar') : t('forms.cancel')}
                </Button>
              </ButtonToolbar>
            </div>
          </CardBody>
        </Card>
      </Col>
    );
  }
}

export default reduxForm({
  form: 'estadoEdit', 
})(withTranslation('common')(CrudEdit));
